export default {
    originAgents: state => state.originAgents,
    excludeAgentIds: state => state.info.excludeAgentIds,
    useExternalUrl: state => state.info.useExternalUrl,
    totalAgentsCount: state => state.info.totalAgentsCount,
    customAgents: state => state.info.customAgents,
    autoSort: state => state.info.autoSort,
    pageNum: state => state.info.pageNum,
    showSearchInput: state => state.info.showSearchInput,
    showSearchBar: state => state.info.showSearchBar,
    allTotal: state => state.info.allTotal,
    searchResults: state => state.searchResults
};
